function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M769 534.975L359.2 935.5a51.45 51.45 0 01-71.575 0l-47.8-46.7a48.675 48.675 0 01-.075-69.875L564.5 500 239.75 181.075a48.675 48.675 0 01.075-69.875l47.8-46.7a51.45 51.45 0 0171.575 0L769 465c19.75 19.325 19.75 50.625 0 69.95z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M958.313 590H607.05a16.5 16.5 0 00-14.707 8.96 16.732 16.732 0 001.3 17.415l128.688 181.281c.043.063.09.121.133.184a36.769 36.769 0 017.219 21.816v147.797a16.429 16.429 0 0016.433 16.535c2.227 0 4.426-.445 6.48-1.297l72.313-27.574c6.48-1.976 10.781-8.09 10.781-15.453V819.656a36.774 36.774 0 017.215-21.816c.043-.063.09-.121.133-.184l128.684-181.289a16.717 16.717 0 001.3-17.406 16.502 16.502 0 00-14.71-8.961zM826.78 785.992a56.931 56.931 0 00-11.097 33.664v117.578l-66 25.164V819.656a56.909 56.909 0 00-11.102-33.664L613.648 610h338.07zm0 0",
  fill: "#000"
})));